import React from 'react';
import { TextareaAutosize, Button, Box, Icon } from '@material-ui/core';
import { debounce } from 'lodash';

const AssistantInput = ({ onSubmit, isLoading, value, onChange, classes }) => {
  const handleChange = (event) => {
    onChange && onChange(event);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit && onSubmit(event);
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextareaAutosize
        id="description"
        aria-label="description textarea"
        placeholder={isLoading ? "Thinking..." : "Where to? Ask anything.."}
        rowsMin={1}
        variant="outlined"
        name="description"
        className={classes.textfieldArea}
        value={value || ''}
        onChange={handleChange}
        disabled={isLoading}
      />
      <Box className={classes.secondRow}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isLoading}
          className={classes.sendButton}
        >
          <Icon>{isLoading ? 'sync' : 'arrow_forward'}</Icon>
        </Button>
      </Box>
    </form>
  );
};

export default AssistantInput;
